import { ChangeEvent, useEffect, useState } from 'react'
import useDebounce from '../../hooks/useDebounce'
import C from '@utilities/constants'

const SelectPage = ({
  page,
  totalPages,
  pageChange,
}: {
  page: number
  totalPages: number
  pageChange: (pageId: number) => void
}) => {
  const [pageNumber, setPageNumber] = useState<number | undefined>(page)
  const debouncedValue = useDebounce<number | undefined>(pageNumber, 500)

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    if (isNaN(value) || value > totalPages) return
    setPageNumber(value ? value : undefined)
  }

  useEffect(() => {
    setPageNumber(page)
  }, [page])

  useEffect(() => {
    if (!debouncedValue) return
    pageChange(debouncedValue)
  }, [debouncedValue])

  if (totalPages <= C.DEFAULT.PAGINATION.PAGE_NUMBER_SHOWING) return <></>
  return (
    <div className={'flex flex-row items-center my-2'}>
      <input
        type="text"
        id="default-input"
        className="text-center py-1 px-2 mr-1 w-14 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block"
        maxLength={3}
        value={pageNumber}
        onChange={onChange}
      />
      / {totalPages}
    </div>
  )
}

export default SelectPage
